var map = {
	"./accordion.js": 225,
	"./animation.js": 634,
	"./barba.js": 511,
	"./cursor.js": 849,
	"./footer.js": 596,
	"./forms.js": 992,
	"./header.js": 194,
	"./home.js": 864,
	"./insights.js": 114,
	"./lenis.js": 353,
	"./navigation.js": 577,
	"./once.js": 454,
	"./projects.js": 873,
	"./slider.js": 733,
	"./swiper.js": 62,
	"./theme.js": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;